import { useTranslation } from "react-i18next";

type Stat = {
	value: string;
	label: string;
};

export default function LandingStatsBar() {
	const { t } = useTranslation();

	const items = t("questionnaire.landingStats.items", {
		returnObjects: true,
	}) as Stat[];

	return (
		<section className="w-full border-b border-[#E6E6EC] bg-white">
			<div className="w-full max-w-[1420px] mx-auto px-4 md:px-16 py-8">
				<div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
					{items?.map((item) => (
						<div key={item.label} className="flex flex-col items-center text-center gap-1 px-2">
							<span className="font-urbanist text-[24px] md:text-[28px] font-bold leading-[120%] text-[#1D243C]">
								{item.value}
							</span>
							<span className="font-urbanist text-[14px] leading-[140%] text-[#626373]">
								{item.label}
							</span>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
